"use client"

import { Button } from "@/components/ui/button";
import { Link } from "@/components/CustomLink";
import ArrowDownRightIcon from "@heroicons/react/24/solid/ArrowDownRightIcon";
import { cn } from "@/lib/utils";
import BulkOfferDesktopImage from "@/components/layout/bulk-offer/images/BulkOfferDesktopImage";
import { useTranslation } from "@/hooks/translationContext";
import { usePlausible } from "next-plausible";
import { CLICK_QUOTE_EVENT_SECTIONS, PLAUSIBLE_GOAL_KEYS } from "@/@core/constants/plausible";
import { useContactWithVenuesLink } from "@/hooks/useContactWithVenuesLink";
import { useIsAskQuestionEnabled } from "@/hooks/useIsAskQuestionEnabled";

export default function BulkOfferDesktop({ largeButton = true, desktopClassName }: { largeButton: boolean, desktopClassName: string }) {
    const {t} = useTranslation();
    const plausible = usePlausible();
    const buttonWidth = largeButton ? "w-[261px]" : "w-[144px]";
    const getQuoteHref = useContactWithVenuesLink();
    const isAskQuestionEnabled = useIsAskQuestionEnabled();

    const sendPlausibleEvent = () => {
        plausible(PLAUSIBLE_GOAL_KEYS.CLICK_QUOTE_EVENT, {
            props: {
                section: CLICK_QUOTE_EVENT_SECTIONS.DESKTOP_BULK_OFFER,
            },
        });
    };

    if (!isAskQuestionEnabled) return null;

    return (
        <Link onClick={() => sendPlausibleEvent()} aria-label={`${t("quote-button-title")}`} href={getQuoteHref}>
            <div
                className={cn(
                    "md:flex hidden gap-3 mt-20 items-end w-full bg-gradient-to-r from-rose-600 to-pink-700 rounded-[32px]",
                    desktopClassName,
                )}
            >
                <BulkOfferDesktopImage />

                <div className="flex cursor-pointer h-[90px] justify-between items-center ml-[168px] pr-6 py-4 w-full">
                    <span className="text-sm font-bold flex flex-col text-white">
                        <span className="text-xs font-medium">{t('bulk-offer-welcome-title')}</span>
                        {t("bulk-offer-card-description")}
                    </span>

                    <div className="flex gap-4 items-center">
                        <div className="flex gap-2 items-center text-white">
                            <span>{t("bulk-offer-card-short-description")}</span>
                            <ArrowDownRightIcon className="size-4 text-xl" />
                        </div>

                        <Button
                            variant="white"
                            className={`${buttonWidth} active:scale-100 text-secondary`}
                        >
                            {t("quote-button-title")}
                        </Button>
                    </div>
                </div>
            </div>
        </Link>
    )
}